import React, { useState } from 'react';

import Image from 'next/image';
import classNames from 'classnames';
import styles from './PreexistingConditionsHeader.module.scss';
import { preexistingConditionsHeaderText } from '@/utils/generalTexts';
import PreexistingConditionsModal from './PreexistingConditionsModal';
import { CAT } from '@/utils/assets';

type PreexistingConditionsHeaderT = {
  availablePlans: number;
  showImage?: boolean;
  className?: string;
};

function PreexistingConditionsHeader({
  availablePlans,
  showImage,
  className,
}: PreexistingConditionsHeaderT) {
  const [isOpen, setIsOpen] = useState(false);
  const handleClick = () => setIsOpen(!isOpen);

  const preexistingConditionsHeaderClass = classNames(styles.preexisting_conditions, {
    [`${className}`]: className,
  });

  return (
    <div className={preexistingConditionsHeaderClass}>
      <PreexistingConditionsModal
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        availablePlans={availablePlans}
      />
      <div className={styles.preexisting_conditions_container}>
        {showImage && (
          <Image src={CAT.CAT_POINTING_PREEXISTING} alt="gato bice vida" height={48} width={61} />
        )}
        <div className={styles.preexisting_conditions_text}>
          <div>{preexistingConditionsHeaderText.content(availablePlans)}</div>
          <div className={styles.preexisting_conditions_text_btn} onClick={handleClick}>
            {preexistingConditionsHeaderText.btn}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PreexistingConditionsHeader;
